import React, { Children } from 'react';
import { Row } from 'antd';

const FilterRow = ({ children, ...props }) => {
  const childArray = Children.toArray(children);
  const hasChildren = childArray.some((child) => Boolean(child.props.children));

  if (!hasChildren) {
    return null;
  }

  return <Row {...props}>{children}</Row>;
};

export default FilterRow;
